import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import './Location.css';

const Location = ({ data }) => {
	if (!data) return null;

	const hasLocation = data.clinicName || data.clinicAddress || data.city;

	if (!hasLocation) {
		return (
			<div className="locations-container">
				<p style={{ color: '#888', textAlign: 'center', padding: '2rem 0' }}>
					No location information available for this doctor.
				</p>
			</div>
		);
	}

	const addressParts = [data.clinicAddress, data.city, data.country].filter(Boolean).join(', ');

	return (
		<div className="locations-container">
			<div className="locations-grid">
				<div className="location-card">
					<div className="location-card__header">
						<div>
							{data.clinicName && <h3 className="location-card__name">{data.clinicName}</h3>}
							{data.specialization && <p className="location-card__specialty">{data.specialization}</p>}
						</div>
					</div>

					<div className="location-card__info">
						{addressParts && (
							<div className="location-card__info-item">
								<FaMapMarkerAlt className="location-card__icon" />
								<div>
									<p>{addressParts}</p>
								</div>
							</div>
						)}

						{data.phone && (
							<div className="location-card__info-item">
								<FaPhoneAlt className="location-card__icon" />
								<div>
									<p>{data.phone}</p>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Location;
